<template>
  <div
    class="group-manage conmon-top"
    style="height: 100%;"
  >
    <el-container style="overflow-x: hidden;">
      <!--左侧分组-->
      <el-aside
        class="left-aside-type"
        width="220px"
        style="margin-top: 24px;margin-left: 20px"
      >
        <div class="group-search">
          <el-input
            placeholder="请输入内容"
            v-model.trim="groupNameTmp"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
              @click="searchGroupType"
            ></i>
          </el-input>
        </div>
        <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen"
          @close="handleClose"
          text-color="#333"
          active-text-color="#333"
        >
          <el-menu-item
            :class="item.choosen ? 'getIt' : ''"
            :index="index + ''"
            v-for="(item, index) in groups"
            :key="index"
            @click="chooseGroupType(index, item)"
          >
            <div
              class="menu-btn"
              v-if="item.name !== '全部'"
            >
              <i
                      v-if="butsObj.edit_group"
                @click="editGroupTypeItem(item)"
                class="el-icon-edit"
                style="margin-right: 0"
              ></i>
              <i
                      v-if="butsObj.del_group"
                @click="deleteGroupTypeItem(item)"
                class="el-icon-close"
                style="margin-right: 0"
              ></i>
            </div>
            <span
              class="menu-title"
              :title="item.name"
            >{{ item.name }}</span>
          </el-menu-item>
          <div
                  v-if="butsObj.add_group"
            class="add-group-btn"
            @click="addGroup"
          >
            <i
              class="el-icon-circle-plus-outline"
              title="添加分组"
            ></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: 100%; overflow-x: hidden;">
        <div
          class="base-input ovf-hd"
          style="margin-bottom: 10px; overflow-x: hidden;"
        >
          <el-row class="search-title">
            <el-col
              :span="4"
              class="table-title"
            >
              <i
                class="el-icon-search"
                style="font-weight: bold"
              ></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col
              :span="20"
              class="text-align-right"
            >
              <el-button
                class="fold-button"
                type="text"
                @click="hide=!hide"
                v-show="hide"
              >收起查询</el-button>
              <el-button
                class="fold-button"
                type="text"
                @click="hide=!hide"
                v-show="!hide"
              >展开查询</el-button>
              <i
                v-if="hide === true"
                class="el-icon-arrow-up search-open-close-i"
                @click="hide=!hide"></i>
              <i
                v-if="hide === false"
                class="el-icon-arrow-down search-open-close-i"
                @click="hide=!hide"></i>
              <el-button
                class="search-btn-new"
                type="primary"
                size="small"
                @click="searchLoad"
              >查询
              </el-button>
            </el-col>
          </el-row>
          <el-row
            class="search-content common-search-formtype"
            v-show="hide"
          >
            <el-col
              :span="24"
              class="text-align-left"
            >
              <span style="margin-left: 50px">输入搜索：</span>
              <el-input
                placeholder="群组名称"
                clearable
                @keyup.enter.native="searchLoad"
                v-model.trim="search.name"
              ></el-input>
            </el-col>
          </el-row>
        </div>
        <el-row
          class="search-title common-table-top"
          style="padding-right:0"
        >
          <el-col
            :span="6"
            class="table-title name-wrapper"
          >
            <i
              class="el-icon-document"
              style="font-weight: bold;"
            ></i>
            <span
              :title="useName + '群组列表'"
              v-text="useName"
            ></span>
          </el-col>
          <el-col
            :span="18"
            class="text-align-right"
          >
            <span style="margin-left: 20px">移到分组：</span>
            <el-select
              class="common-search-formtype"
              style="margin-right: 13px"
              v-model="group_id"
              @change="confirmChooseGroupType"
              :disabled="checkAll"
              placeholder="请选择目标分组"
            >
              <el-option
                v-for="item in queryGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <!--<div class="add-btn">导入客户</div>-->
            <el-button
              type="primary"
              class="add-btn btn-right"
              style="float: right;"
              @click="reloadCustomerNum"
            >刷新</el-button>
            <el-button
              type="primary"
              v-if="butsObj.add"
              class="add-btn list-btn-margin"
              @click="toAddGroup"
            >新建群组</el-button>
          </el-col>
        </el-row>
        <!--群组列表-->
        <el-table
          key="tableData"
          id="tableData"
          ref="multipleTable"
          :data="tableData"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          class="table-checkbox-style"
        >
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="toAddGroup">新建</span></div>
          </template>
          <el-table-column
            type="selection"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="群组名称"
          >
            <template slot-scope="scope">
              <el-popover
                trigger="hover"
                placement="top"
              >
                <p>{{ scope.row.name }}</p>
                <div
                  slot="reference"
                  class="name-wrapper"
                  style="color:#606266"
                >
                  <router-link
                          v-if="butsObj.add"
                    :to="{ path: '/home/aud-group-manage-detail/' + modelId, query: { id: scope.row.id, type: scope.row.type }}"
                    class="op-link"
                    style="margin-left: 0;text-decoration: none"
                  >
                    {{ scope.row.name }}
                  </router-link>
                  <div v-else>{{ scope.row.name }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="客户人数"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.number === -1">正在统计中</span>
              <span v-if="scope.row.number !== -1">{{ scope.row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              {{ groupsType[scope.row.type] }}
            </template>
          </el-table-column>
          <el-table-column
            label="更新时间"
            min-width="115"
          >
            <template slot-scope="scope">
              {{ scope.row.updateTimeStr }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            min-width="115"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createTimeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            style="display: flex;justify-content: center"
          >
            <template slot-scope="scope">
              <!--<div class="op-link" @click="edit(scope.row)">-->
              <!--<i class="iconfont icon-icon-bianji" style="font-size: 14px"></i>-->
              <!--<span>编辑</span>-->
              <!--</div>-->
              <router-link
                      v-if="butsObj.details"
                :to="{ path: '/home/aud-group-manage-detail/' + modelId, query: { id: scope.row.id, type: scope.row.type }}"
                class="op-link"
                style="margin-left: 0;text-decoration: none"
              >
                查看
              </router-link>
              <div
                      v-if="butsObj.del"
                class="op-link deleteColor"
                @click="deleteItem(scope.row)"
              >
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="table-foot"
          style="text-align: right"
        >
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="total, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </el-container>

    <!--添加群组分组弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="创建群组分组"
      :visible.sync="adddialog"
      width="520px"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
      >
        <el-form-item
          label="分组名称:"
          :label-width="addLabelWidth"
        >
          <el-input
            maxlength="20"
            class="stockInput"
            type="text"
            v-model="addForm.name"
            auto-complete="off"
            placeholder="输入群组分组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="cancelAdd"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="btnDisabled"
          class="dialog-confirm-btn"
          type="primary"
          @click="submitAddGroupAction('addForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑群组分组弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="编辑群组分组"
      :visible.sync="editdialog"
      width="520px"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
      >
        <el-form-item
          label="分组名称:"
          prop="name"
          :label-width="addLabelWidth"
        >
          <el-input
            maxlength="20"
            class="stockInput"
            type="text"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="输入群组分组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="editdialog = false"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="btnDisabled"
          class="dialog-confirm-btn"
          type="primary"
          @click="submitEditGroupAction('editForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGroupTypeList, addGroupType, deleteGroup, addGroup, getCustomerList } from '@/api/customer.js'
import { getCusTypes, getAudGroupList, deleteAudienceGroup, getAudGroupGroupList, addAudGroupGroup, editGroupType, deleteAudGroupType, confirmChooseGroupType } from '@/api/set.js'
import { GROUP_TYPE, GROUP_TYPE_OBJ } from './constant'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'groupManage',
  data() {
    return {
      btnDisabled: false,
      modelId: '',
      useName: '',
      groupType: GROUP_TYPE,
      editFormRules: {
        name: [
          { required: true, message: '分组名字不能为空', trigger: 'change' }
        ]
      },
      addFormRules: {
        name: [
          { required: true, message: '分组名字不能为空', trigger: 'change' }
        ]
      },
      loading: false,
      queryGroups: [],
      tableData: [],
      customerData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      search: {
        name: ''
      },
      group_id: '',
      groupNameTmp: '',
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      groupsType: GROUP_TYPE_OBJ,
      createGroupType: 0,
      groupTypeIndex: 0,
      isDisabled: false,
      lastId: 0,
      allTerms: {},
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ],
      result: [],
      len: 0,
      butsObj: { // button按钮列表
        add_group: false,
        details: false,
        del: false,
        add:false,
        edit_group: false,
        del_group: false,
        move_to_group: false
      }
    }
  },
  computed: {
    Newitems() {
      let _this = this
      let Newitems = []
      if (_this.groupNameTmp === '') {
        return
      }
      _this.groups.map(function (item) {
        if (item.name.search(_this.groupNameTmp) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    loadAudGroupGroupList() {
      getAudGroupGroupList(this.modelId, this.groupNameTmp).then(res => {
        this.queryGroups = JSON.parse(JSON.stringify(res.data.result))
        if (res.data.code === '200') {
          for (let item of res.data.result) {
            item.choosen = false
          }
          this.groups = res.data.result
          this.groups.unshift({ id: '', name: '全部' })
          console.log('this.groups', this.groups)
        }
      })
    },
    // 获取列表名字
    getAudiencesName(modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.params.id
          for (let item of this.modelData) {
            if (item.id == id) {
              this.useName = item.name + '群组列表'
              let arr = to.meta.routeArr
              arr[0].name = item.name
              arr[0].Rpath = '/home/audiences-group-manage/' + modelId
              arr[1].name = item.name + '群组管理'
              arr[1].Rpath = '/home/audiences-group-manage/' + modelId
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    searchLoad() {
      this.page = 1
      this.load()
    },
    // 刷新人数状态
    reloadCustomerNum() {
      this.load()
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
    },
    // 查找群组类型
    searchGroupType() {
      let flag = 0
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.groups[i].id === this.Newitems[j].id) {
            this.groups[i].choosen = true
            flag++
          }
        }
      }
      if (flag === 0) {
        _g.toastMsg('error', '没有匹配的分组')
      }
      this.loading = true
      this.loading = false
      // this.load()
    },
    // 点选群组类型
    chooseGroupType(index, item) {
      this.groupTypeIndex = index
      this.search.group_id = item.id
      this.group_id = item.id
      this.load()
    },
    // 取消创建群组
    cancelCreate() {
      this.createGroupType = 0
      this.page = 1
      this.newGroupName = ''
      this.customerData = []
      this.load()
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '真实姓名',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
    },
    // 确认移到分组
    confirmChooseGroupType() {
      let params = {
        groupId: this.group_id,
        ids: this.deleteArrayIds
      }
      confirmChooseGroupType(params).then((res) => {
        if (res.data.code === '200') {
          this.group_id = ''
          this.load()
          _g.toastMsg('success', '移动群组成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 全选
    handleSelectionChange(val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        if(this.butsObj.move_to_group) {
          this.checkAll = false
        } else {
          this.checkAll = true
        }
      } else {
        this.checkAll = true
      }
    },
    // 列表删除
    deleteItem(item) {
      this.$confirm('确认删除该群组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let modelId = this.$route.params.id
        deleteAudienceGroup(modelId, item.id).then((res) => {
          if (res.data.code == 200) {
            this.load(modelId)
            _g.toastMsg('success', '删除群组成功')
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    // 加载群组列表
    load(modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      this.loading = true
      getAudGroupList(modelId, this.page, this.limit, this.search.name, this.group_id).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
          this.closeLoading()
        }
      })
    },
    // 数据加载时的动画
    closeLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 新建群组跳页
    toAddGroup() {
      let modelId = this.$route.params.id
      router.push({ path: '/home/audiences-group-manage-add/' + modelId })
    },
    // 添加群组分组
    addGroup() {
      this.adddialog = true
      this.addForm.name = ''
    },
    // 左侧分组导航
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    // 收起筛选和展开筛选
    closeAndOpen() {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 删除群组分组
    deleteGroupTypeItem(item) {
      this.$confirm('确认删除该群组分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAudGroupType(item.id).then((res) => {
          if (res.data.code === '200') {
            this.loadAudGroupGroupList()
            _g.toastMsg('success', '删除群组分组成功')
            this.adddialog = false
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 编辑群组分组
    editGroupTypeItem(item) {
      this.editdialog = true
      this.editForm.name = item.name
      this.editGroupTypeId = item.id
    },
    submitEditGroupAction(formName) {
      if (this.btnDisabled === true) {
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmEdit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    confirmEdit() {
      this.btnDisabled = true
      let params = {
        id: this.editGroupTypeId,
        name: this.editForm.name,
        modelId: this.modelId
      }
      editGroupType(params).then((res) => {
        setTimeout(() => {
          this.btnDisabled = false
        }, 1000)
        if (res.data.code === '200') {
          this.loadAudGroupGroupList()
          _g.toastMsg('success', '编辑群组分组成功')
          this.editdialog = false
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    submitAddGroupAction(formName) {
      if (this.btnDisabled === true) {
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 创建群组分组弹窗确定
    confirmAdd() {
      let params = {
        name: this.addForm.name,
        modelId: this.modelId
      }
      this.btnDisabled = true
      addAudGroupGroup(params).then((res) => {
        setTimeout(() => {
          this.btnDisabled = false
        }, 1000)
        if (res.data.code === '200') {
          this.loadAudGroupGroupList()
          _g.toastMsg('success', '添加群组分组成功')
          this.adddialog = false
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 关闭群组分组弹窗
    cancelAdd() {
      this.adddialog = false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.modelId = to.params.id
      vm.getAudiencesName(to.params.id, to)
      // vm.loadAudGroupGroupList()
      vm.load(to.params.id)
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.modelId = to.params.id
    this.loadAudGroupGroupList()
    this.getAudiencesName(to.params.id, to)
    this.load(to.params.id)
    next()
  },
  created() {
    this.modelId = this.$route.params.id
    this.loadAudGroupGroupList()
    this.getButtonsList()
  }
}
</script>

<style scoped>
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
@media only screen and (max-width: 1450px) {
  .text-align-right .fold-button-content {
    display: none;
  }
  .text-align-right .dropdown-btn-content {
    display: inline-block;
  }
}
.fold-button-content {
  float: right;
  display: inline-block;
}
.dropdown-btn-content {
  display: none;
}
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.disabled {
  background: #ccc !important;
}
.getIt {
  color: #ff5500 !important;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5; /*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc; /*滚动条的背景颜色*/
}
.el-dropdown-link {
  display: inline-block;
  background-color: #1890FF;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 92px;
  border-radius: 20px;
  color: #fff;
  outline: none;
  margin-right: 10px;
  cursor: pointer;
}
</style>
